module.exports = __webpack_public_path__ + "img/RescueHaus_Logo.40830cc6.png";